import type { ConditionField } from "../../../../../../../../../../api/types/svTypes";
import { ItemDataType } from "../../../../../../../../../../api/types/svTypes";
import { getFieldCaption } from "../../../../../../utilities/Utilities";

const supportedTypes: ItemDataType[] = [ItemDataType.Date, ItemDataType.General];

export const isConditionValueSupported = (condition: ConditionField): boolean => {
  return condition.validation?.invalid !== true && supportedTypes.includes(condition.meta.type);
};

export const getConditionFieldCaption = (condition: ConditionField): string => {
  return getFieldCaption(condition);
};
